import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Manage passes</Typography>
    <p>This table lists passes issued from the selected template. Use the Test/Live switch to choose the pass mode. Results are loaded in batches as you scroll, so large templates do not load every pass into the browser at once.</p>

    <Typography variant='h5'>Search, filter and sorting</Typography>
    <p>Search, column filters and sort order are applied by the server. The status line shows the number matching the current criteria and how many are presently loaded. Changing the template, mode, filter or sort order clears the previous selections.</p>

    <Typography variant='h5'>Two kinds of selection</Typography>
    <ul>
      <li><strong>Current pass:</strong> click anywhere on a row other than its checkbox to toggle the current pass. Its row highlight enables single-pass actions such as View Pass Details, Edit Pass, Scan Actions, Scan History and Install Pass.</li>
      <li><strong>Checkbox selection:</strong> tick rows to select several passes for bulk actions. This selection is separate from the current pass.</li>
    </ul>
    <p>Select all applies to all passes matching the current server-side filters, not just the currently loaded batch. Bulk-action confirmation lets you choose between all matching passes and the loaded checked rows where that distinction matters.</p>

    <Typography variant='h5'>Table actions and modal dialogs</Typography>
    <ul>
      <li><strong>Edit selected passes:</strong> opens the shared pass editor for editable variables only. Read-only and encrypted variables are excluded; entered values are validated before saving.</li>
      <li><strong>Delete selected passes:</strong> permanently deletes the loaded, checked passes after confirmation. When Select all matching is active, deletion is limited to the loaded checked rows.</li>
      <li><strong>Refresh data:</strong> reloads the current template, mode, filters and sort order.</li>
      <li><strong>Export:</strong> downloads the rows currently loaded in the table. Use filters first to narrow the export.</li>
    </ul>

    <Typography variant='h5'>Columns</Typography>
    <p>The standard columns show pass ID, creation date, current/expired status, expiry, installation status, and today’s update/synchronisation/notification count. Template variables may add extra columns. Managed-pass tables omit barcode fields because they are generated and maintained by Smartix.</p>
  </div>
)

export default HelpText
